import { money, pageInfo } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const fetchDisputesList = gql`
  query fetchDisputesList(
    $first: Int!
    $filter: DisputesFilterInput!
    $transactionFirst: Int!
  ) {
    disputes(first: $first, filter: $filter) {
      edges {
        node {
          id
          accountNumberLast4
          claimId
          accountNumberMasked
          disputedAmount {
            ...money
          }
          numberOfCharges
          processSteps {
            title
            message
            isComplete
          }
          transactionsConnection(first: $transactionFirst) {
            edges {
              node {
                id
                createdAt
                description
                value {
                  ...money
                }
              }
            }
            pageInfo {
              ...pageInfo
            }
          }
        }
      }
    }
  }
  ${money}
  ${pageInfo}
`;

export default fetchDisputesList;
